import propEq from 'ramda/src/propEq';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { OfferingMetadataByIdSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { fetchOfferingFacetCategoryTypes, fetchOfferingFacetTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { ContextOfferingAction, DEVICE_TYPE_OFFER, OPTION_OFFERING_CHARGE_TYPE } from '../../../../reducers/constants/wizard.constants';
import { ORDER_SCENARIOS } from '../../../../customercare.constants';
import { IsLoadedSelector } from './offerings.selectors';
import { IsFetchingSelector, NumberOfPagesSelector, PageNumberSelector, RecordCountSelector, SelectedPageSizePreference } from '../../../../reducers/selectors/offering.order.selectors';
import { SelectedContractSelector } from '../../../../reducers/selectors/contract.selectors';
import { keywordSearch, keywordSearchWithCustomerId, setSelectedOfferName, setPageNumber, setPageSizePreference } from '../../../../reducers/actions/offering.order.actions';
import { setSelectedContract } from '../../../../reducers/actions/contract.details.actions';
// TODO - Customer Order wizard componentized steps should not be importing anything from a specific wizards
import { EditCustomerInfoSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { PagesIsFetchingDataSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import CustomerCareKeys from '../../../../locales/keys';
import { ChangeOfferingInstanceIdSelector } from '../../../../reducers/selectors/add.offer.wizard.selectors';
import { IsFetchingCurrentOfferSelector, TransitionOfferingIdSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
function OfferingsController($timeout, $ngRedux, $anchorScroll, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var MAX_SLOTS_FOR_PAGER = 5;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      changeOfferingInstanceId: ChangeOfferingInstanceIdSelector(store),
      facetCategoriesLoaded: MetadataCodeLoadedSelector(CODES.OfferingFacetCategory, store),
      facetsLoaded: MetadataCodeLoadedSelector(CODES.OfferingFacet, store),
      isFetchingAvailableOffers: IsFetchingSelector(store),
      isFetchingCurrentOffer: IsFetchingCurrentOfferSelector(store),
      isFetchingDecisionPages: PagesIsFetchingDataSelector(store),
      isLoaded: IsLoadedSelector(store),
      maximumSlots: MAX_SLOTS_FOR_PAGER,
      newConnectCustomer: EditCustomerInfoSelector(store),
      numberOfPages: NumberOfPagesSelector(store),
      offeringMetadata: OfferingMetadataByIdSelector(store),
      pageNumber: PageNumberSelector(store),
      recordCount: RecordCountSelector(store),
      selectedContract: SelectedContractSelector(store),
      selectedPageSizePreference: SelectedPageSizePreference(store),
      transitionOfferingId: TransitionOfferingIdSelector(store),
      userPageSizePreference: PageSizePreferenceSelector(store)
    };
  };
  this.$onInit = function () {
    _this.TRANSITION = ContextOfferingAction.TRANSITION;
    var controllerActions = {
      fetchOfferingFacetCategoryTypes: fetchOfferingFacetCategoryTypes,
      fetchOfferingFacetTypes: fetchOfferingFacetTypes,
      keywordSearch: keywordSearch,
      keywordSearchWithCustomerId: keywordSearchWithCustomerId,
      retrieveOfferingsMetadata: retrieveOfferingsMetadata,
      setPageNumber: setPageNumber,
      setPageSizePreference: setPageSizePreference,
      setSelectedContract: setSelectedContract,
      setSelectedOfferName: setSelectedOfferName
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.customerCareKeys = CustomerCareKeys;
    if (!_this.state.facetCategoriesLoaded) {
      _this.actions.fetchOfferingFacetCategoryTypes();
    }
    if (!_this.state.facetsLoaded) {
      _this.actions.fetchOfferingFacetTypes();
    }
    _this.keyword = '';
    _this.offerGrayoutFilter = _this.offerGrayoutFilter || _this.defaultFilter;
    _this.currentOfferType = null;
    if (_this.state.transitionOfferingId) {
      _this.actions.retrieveOfferingsMetadata([_this.state.transitionOfferingId]).then(function () {
        _this.currentOfferType = _this.state.offeringMetadata[_this.state.transitionOfferingId].OfferType;
        _this.searchForPage(1);
      }).catch(function (error) {
        uiNotificationService.transientError(error.translatedMessage);
      });
    } else {
      _this.searchForPage(1);
    }
    _this.setShowContractSection();
  };
  this.$onChanges = function (changesObj) {
    if (changesObj.selectedOfferId) {
      if (changesObj.selectedOfferId.isFirstChange() && !changesObj.selectedOfferId.currentValue) {
        _this.setCurrentStepIsInvalid()(true);
      } else {
        _this.setSelectedOfferEditCopy()(_this.selectedOfferId);
      }
    }
    if (changesObj.contracts && !changesObj.contracts.isFirstChange()) {
      _this.setShowContractSection();
    }
    if (changesObj.continueClicked && _this.continueClicked) {
      $anchorScroll('top');
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.defaultFilter = function () {
    return function () {
      return true;
    };
  };
  this.setShowContractSection = function () {
    _this.showContractSection = !_this.hideContractSection && (_this.orderScenario === ORDER_SCENARIOS.NEW_CONNECT || _this.orderScenario === ORDER_SCENARIOS.ADD_OFFER) && _this.contracts.length && (!_this.isMultiOffer || _this.state && _this.state.selectedContract);
  };
  this.performSearch = function () {
    if (!_this.state.selectedPageSizePreference) {
      _this.actions.setPageSizePreference(_this.state.userPageSizePreference);
    }
    var additionalOptions = {
      // This currency code implementation is a temporary solution, should use the one on the subscriber
      // if it exists which it should on add flow
      currencyCode: _this.currencyCode,
      chargeTypeIdsSelector: _this.offeringChargeTypeIdSelector(),
      facetIdsSelector: _this.selectedFacetIdsSelector(),
      keyword: _this.keyword,
      nonBulkOnly: _this.nonBulkOnly,
      offerType: _this.currentOfferType >= 0 ? _this.currentOfferType : null,
      orderScenario: _this.orderScenario,
      pageNumber: _this.state.pageNumber,
      pageSize: _this.state.selectedPageSizePreference
    };
    if (_this.customerId) {
      _this.state.changeOfferingInstanceId ? _this.actions.keywordSearchWithCustomerId(_this.customerId, additionalOptions, _this.contextOfferingAction, DEVICE_TYPE_OFFER) : _this.actions.keywordSearchWithCustomerId(_this.customerId, additionalOptions, _this.contextOfferingAction);
    } else {
      additionalOptions['subtenants'] = _this.state.newConnectCustomer.SubtenantId ? [_this.state.newConnectCustomer.SubtenantId] : [];
      _this.actions.keywordSearch(_this.postalCode, _this.state.newConnectCustomer.Category, _this.state.newConnectCustomer.SubscriberTypeCode, _this.state.newConnectCustomer.Language, additionalOptions, _this.contextOfferingAction);
    }
  };
  this.onOfferingSelect = function (offerId) {
    _this.onOfferingSelected()(offerId);
    var offerName = _this.offerOptionViewModel.find(propEq(offerId, 'Id')).DisplayName;
    _this.actions.setSelectedOfferName(offerName);
  };
  this.onOfferingUnselect = function () {
    if (_this.onOfferingDeselected()) {
      _this.onOfferingDeselected()();
    }
    _this.setSelectedOfferEditCopy()(null);
    _this.setSelectedOffer()(null); // The user shouldn't have to continue or go back for this deselection to take effect
    _this.setCurrentStepIsInvalid()(true);
  };
  this.clearSelectedContract = function () {
    _this.actions.setSelectedContract(null);
    _this.searchForPage(1);
  };
  this.openSelectContractPopup = function () {
    _this.contractDialogOpened = true;
    $timeout(_this._contractPopupApi.open);
  };
  this.successContractPopup = function (selectedContract) {
    _this._contractPopupApi.close();
    _this.contractDialogOpened = false;
    _this.actions.setSelectedContract(selectedContract);
    _this.searchForPage(1);
  };
  this.closeContractPopup = function () {
    _this._contractPopupApi.close();
    _this.contractDialogOpened = false;
  };
  this.openContractTermsConditionsPopup = function () {
    _this.contractTermsConditionsPopupOpened = true;
    $timeout(function () {
      _this.contractTermsConditionsPopupApi.open();
    });
  };
  this.handleCloseContractTermsConditionsPopup = function () {
    _this.contractTermsConditionsPopupApi.close();
    _this.contractTermsConditionsPopupOpened = false;
  };
  this.title = i18n.translate(CustomerCareKeys.NARROW_RESULTS);
  this.noAvailableOfferingsMessage = i18n.translate(CustomerCareKeys.NO_OFFERINGS_AVAILABLE);
  this.filtersDescriptor = {
    group: {
      name: 'groupName',
      filters: 'filters'
    },
    filter: {
      name: 'name',
      checked: 'checked',
      disabled: 'disabled'
    }
  };
  this.filterSelected = function (filterGroup, selectedFilter, isChecked) {
    switch (selectedFilter.type) {
      case OPTION_OFFERING_CHARGE_TYPE:
        _this.setSelectedOfferingChargeTypesEditCopy()(selectedFilter.id, !isChecked);
        _this.searchForPage(1);
        break;
      default:
        _this.setSelectedFacetsEditCopy()(selectedFilter.id, !isChecked);
        _this.searchForPage(1);
    }
  };
  this.contractPopupConfig = {
    onRegisterApi: function onRegisterApi(event) {
      _this._contractPopupApi = event.api;
    }
  };
  this.quickViewPopupConfig = {
    onRegisterApi: function onRegisterApi(event) {
      _this._quickViewPopupApi = event.api;
    }
  };
  this.contractTermsConditionsPopupConfig = {
    onRegisterApi: function onRegisterApi(event) {
      _this.contractTermsConditionsPopupApi = event.api;
    }
  };
  this.clearSearchText = function () {
    _this.keyword = undefined;
    _this.searchForPage(1);
  };
  this.keywordGo = function (event) {
    event.preventDefault();
    _this.searchForPage(1);
  };
  this.onQuickView = function (id) {
    _this.quickViewOffer = _this.offerOptionViewModel.find(propEq(id, 'Id'));
    _this.showQuickViewDialog = true;
    $timeout(_this._quickViewPopupApi.open);
  };
  this.handleSelectOfferQuickViewDialog = function (id) {
    _this.onOfferingSelected()(id);
    _this._quickViewPopupApi.close();
    _this.showQuickViewDialog = false;
  };
  this.handleCloseOfferQuickViewDialog = function () {
    _this._quickViewPopupApi.close();
    _this.showQuickViewDialog = false;
  };
  this.searchForPage = function (pageNum) {
    _this.actions.setPageNumber(pageNum);
    _this.performSearch();
  };
  this.onPageSizeOptionSelected = function (pageSize) {
    _this.actions.setPageSizePreference(pageSize);
    _this.searchForPage(1);
  };
  this.shouldShowError = function () {
    return _this.stepIsInvalid && _this.continueClicked;
  };
}
export default {
  template: require('./offerings.html'),
  controller: OfferingsController,
  controllerAs: 'offeringsController',
  bindings: {
    contextOfferingAction: '<',
    continueClicked: '<',
    contracts: '<?',
    currencyCode: '<',
    customerId: '<',
    goToPreviousStep: '&',
    groupedCheckboxFilterOptions: '<',
    hideContractSection: '<?',
    isMultiOffer: '<?',
    nonBulkOnly: '<?',
    offerGrayoutFilter: '&?',
    offeringChargeTypeIdSelector: '&',
    offerOptionViewModel: '<',
    onOfferingDeselected: '&',
    onOfferingSelected: '&',
    orderScenario: '<',
    postalCode: '<',
    selectedFacetIdsSelector: '&',
    selectedOfferId: '<',
    setCurrentStepIsInvalid: '&',
    setSelectedFacetsEditCopy: '&',
    setSelectedOffer: '&',
    setSelectedOfferEditCopy: '&',
    setSelectedOfferingChargeTypesEditCopy: '&',
    stepIsInvalid: '<',
    subtenants: '<'
  }
};